<template>
  <div>
    <b-row>
      <b-col class="col-md-12">
        <b-card>
          <b-row>
            <h2>Operação Catálogo</h2>
          </b-row>
          <b-row align-v="end" class="mt-3">
            <b-col>
              <label for="">Campanha</label>
              <b-form-input
                size="sm"
                v-model="campanha"
                placeholder="1-24"
                @keyup.enter="getOperacoes()"
              ></b-form-input>
            </b-col>
            <b-col>
              <label for="">distribuidor</label>
              <b-form-input
                size="sm"
                v-model="distribuidor"
                placeholder="Nome ou código"
                @keyup.enter="getOperacoes()"
              ></b-form-input>
            </b-col>
            <b-col>
              <label for="">Confirmado</label>
              <b-form-select
                v-model="checked"
                :options="options"
                size="sm"
                @keyup.enter="getOperacoes()"
              ></b-form-select>
            </b-col>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                :disabled="loading"
                @click="buscar()"
              >
                <i class="fas fa-search"></i>
                Buscar</b-button
              >
            </b-col>
            <b-col class="text-right">
              <b-button
                variant="success"
                size="sm"
                :disabled="loading"
                @click="exportar()"
              >
                <i class="far fa-file-excel"></i>
                Exportar</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-table
              :items="distribuidores"
              :fields="fields"
              striped
              hover
              :busy="loading"
              stacked="md"
              show-empty
              empty-text="Nenhum dado encontrado"
              small
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Buscando...</strong>
                </div>
              </template>
              <template #cell(checked)="row">
                {{ row.value.first }} {{ row.value.last }}
                <b-badge v-if="row.value === true" variant="success"
                  >Sim</b-badge
                >
                <b-badge v-else variant="danger">Não</b-badge>
              </template>
            </b-table>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @input="getOperacoes()"
              ></b-pagination>
            </b-col>
            <b-col class="col-md-2 text-right" v-if="total > 0">
              Total: {{ total }}
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      campanha: "",
      currentPage: 1,
      total: 0,
      perPage: 20,
      distribuidores: [],
      distribuidor: "",
      checked: null,
      options: [
        { value: null, text: "" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      fields: [
        {
          key: "distribuidor.codigo",
          label: "Código",
        },
        {
          key: "distribuidor.nome",
          label: "Distribuidor",
        },
        {
          key: "quantidade",
          label: "Quantidade",
          class: "text-center",
        },
        {
          key: "checked",
          label: "Confirmado",
          class: "text-center",
        },
      ],
    };
  },
  methods: {
    exportar() {
      const vm = this
      if (!vm.campanha || vm.campanha == "") {
        vm.$swal("Atenção", "Informe a campanha", "error");
        return;
      }
      const params = {
        campanha: vm.campanha,
        distribuidor: vm.distribuidor,
        checked: vm.checked,
        exportar: true
      };
      vm.loading = true;

      axios
        .get("/adm/operacao-catalogo/exportar", { params: params })
        .then((response) => {
          window.open('/adm/operacao-catalogo/excel/' + response.data.resource, '_blank');
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          vm.loading = false;
        });
    },
    buscar() {
      this.currentPage = 1;
      this.total = 0;
      this.distribuidores = [];
      this.getOperacoes();
    },
    getOperacoes() {
      const vm = this;
      if (!vm.campanha || vm.campanha == "") {
        vm.$swal("Atenção", "Informe a campanha", "error");
        return;
      }
      const params = {
        currentPage: vm.currentPage,
        perPage: vm.perPage,
        campanha: vm.campanha,
        distribuidor: vm.distribuidor,
        checked: vm.checked,
      };
      vm.loading = true;
      axios
        .get("/adm/operacao-catalogo/listar", { params: params })
        .then((response) => {
          vm.distribuidores = response.data.data;
          vm.total = response.data.total;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_operacao_catalogo/Index.vue